<template>
    <div>
        <Row class="expand-row" id="imgToolsExpand">
            <Col span="24">
<!--                医嘱展示-->
            <!--<Card class="card-box">-->
                <!--<p slot="title" class="card-title">患者信息</p>-->
                <!--<div>-->
                    <!--<patient-info-module :patientData="diagnosisModel.patientData"></patient-info-module>-->
                <!--</div>-->
            <!--</Card>-->
            </Col>
            <Col span="24">
            <!--                病历展示-->
            <Card class="card-box">
                <p slot="title" class="card-title">病历</p>
                <div>
                    <patient-diagnose :isFirst="itemIsFirst" :medicalRecordId="row.medicalRecordId"></patient-diagnose>
                </div>
            </Card>
            </Col>
            <Col span="24">
            <!--                体检印象-->
                <Card class="card-box">
                    <p slot="title" class="card-title">体检印象</p>
                    <Row>
                        <Col span="24">
                        <span class="bold-label">诊断：</span>
                        <span>{{diagnosisModel.diagnosisData.content}}</span>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                        <span class="bold-label">医生记录：</span>
                        <span>{{diagnosisModel.diagnosisData.impression}}</span>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <!--                检测检查-->
            <Col span="24">
                <Card class="card-box">
                    <p slot="title" class="card-title">检测检查</p>
                    <Row>
                        <Col span="24">
                        <span>{{diagnosisModel.diagnosisData.examination}}</span>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <Col span="24">
                <!--                饮食计划展示-->
                <Card class="card-box">
                    <p slot="title" class="card-title">饮食计划</p>
                    <div>
                        <Table border stripe
                               :columns="diagnosisModel.dietPlanData.dietPlanTableColumns"
                               :data="diagnosisModel.dietPlanData.itemSet"></Table>
                    </div>
                    <div style="display: flex;flex-direction: row;justify-content: flex-end">
                        <Button type="info" icon="ios-add" style="margin: 10px 10px 0 0" @click.stop="editPlan(diagnosisModel.dietPlanData.dietPlanList)">调整</Button>
                        <!--<Button type="info" icon="ios-add" style="margin: 10px 10px 0 0" @click.stop="editPlan(diagnosisModel.dietPlanData.dietPlanList.infoVOList)">调整</Button>-->
                    </div>
                </Card>
            </Col>
            <Col span="24">
                <!--                营养目标展示-->
                <Card class="card-box">
                    <p slot="title" class="card-title">营养目标</p>
                    <div>

                        <div v-if="diagnosisModel.patientData.age != null && diagnosisModel.patientData.sex != null &&
                                                        diagnosisModel.patientData.weight != null && diagnosisModel.patientData.height != null" style="color: #ff3d1f">
                            <!--男热量计算公式： （66.4230 + 13.7516 * 体重（千克）+ 5.0033 * 身高（厘米） + 6.7750 * 年龄） * 1.375-->
                            <span v-if="diagnosisModel.patientData.sex === '0'">每日需摄入的热量是{{(66.4230 + 13.7516 * diagnosisModel.patientData.weight + 5.0033 * diagnosisModel.patientData.height + 6.7750 * diagnosisModel.patientData.age) * 1.375}}千卡</span>
                            <!--男热量计算公式： （655.0955 + 9.6534 * 体重（千克）+ 1.8496 * 身高（厘米） + 4.6756 * 年龄） * 1.375-->
                            <span v-if="diagnosisModel.patientData.sex === '1'">每日需摄入的热量是{{(655.0955 + 9.6534 * diagnosisModel.patientData.weight +1.8496 * diagnosisModel.patientData.height + 4.6756 * diagnosisModel.patientData.age) * 1.375}}千卡</span>
                        </div>
                        <span v-else>身高/体重/年龄/性别数据不全</span>
                        <Table border stripe max-height="250"  v-if="diagnosisModel.nutritionalGoalData.nutritionalGoalList != null"
                               :columns="diagnosisModel.nutritionalGoalData.nutritionalGoalTableColumns"
                               :data="diagnosisModel.nutritionalGoalData.nutritionalGoalList.nutritionalGoalInfos"
                        ></Table>
                        <span v-else>暂未设置</span>
                    </div>
                </Card>
            </Col>
            <Col span="24">
            <Card class="card-box">
                <p slot="title" class="card-title">药品营养素说明</p>
                <div>
                    <Card style="margin: 10px 0" :key="item.medicalId" v-for="(item, i) in medicineUsage" v-if="medicineUsage != null">
                        <h3>{{i+1 + '.' + item.medicine.name}}</h3>
                        <p v-if="item.medicineNum > 0">数量：{{item.medicineNum}}盒</p>
                        <div style="display: flex;flex-direction: row">
                            <p>用法用量：{{item.channel ? item.channel : ''}} </p>
                            <p>&nbsp;&nbsp;{{item.usage ? item.usage : '' }}</p>
                            <p>&nbsp;&nbsp;使用{{item.day ? item.day : 0}}天 </p>
                        </div>
                        <p v-if="item.remark != null && item.remark !== ''">补充说明：{{item.remark}}</p>
                    </Card>
                </div>
            </Card>
            <!--                其它注意事项-->
            <Card class="card-box">
                <p slot="title" class="card-title">其它注意事项</p>
                <Row>
                    <Col span="24">
                    <span>{{diagnosisModel.diagnosisData.doctorAdvice}}</span>
                    </Col>
                </Row>
            </Card>
            </Col>
        </Row>
        <Modal v-model="updateModel" :styles="{top: '20px'}" title="食谱调整" width="85%">
            <Table border max-height="670" stripe :columns="columnsAdd" :data="itemAdd">
                <template v-for="week in weekList" slot-scope="{ row, index }" :slot="week">
                    <Form style="margin: 10px 0" v-if="index < 4">
                        <Row v-for="(templateInfo,indes) in updateInfoItem.infoVOList[row[week]]" :key="indes">
                            <!--<div v-for="(templateInfo, idx) in templat.infoList">-->
                              <Col span="12">
                              <FormItem style="margin: 10px 5px">
                                <Select v-if="templateInfo.select.edit"
                                        @mouseout.native="!templateInfo.select.click ? templateInfo.select.edit = false : null"
                                        @click.native="templateInfo.select.click = true"
                                        @on-change="changeSelect($event, templateInfo)" label-in-value
                                        transfer filterable  v-model="templateInfo.foodMaterialId" placeholder="请选择食材">
                                  <Option v-for="item in foodMaterialAllList" :value="item.id" :label="item.name" :key="item.id">{{ item.name }}</Option>
                                </Select>
                                <div v-else @mouseover="templateInfo.select.edit = true"
                                     style="height: 30px;line-height: 30px;border: 1px solid rgb(220, 222, 226);border-radius: 4px;background-color: white"
                                >
                                  {{templateInfo.foodMaterial != null && templateInfo.foodMaterial.name != null ? templateInfo.foodMaterial.name : templateInfo.foodMaterialName}}
                                </div>
                              </FormItem>
                              </Col>
                              <Col span="6">
                              <FormItem style="margin: 10px 5px">
                                <InputNumber style="width: 75px" :min="0" v-model="templateInfo.value"placeholder="请输入食材数量"></InputNumber>
                                <span style="padding-left: 5px">克</span>
                              </FormItem>
                              </Col>
                              <Col span="2">
                              <Poptip :transfer="true" placement="right">
                                <Button class="my_Button" title="备注" style="border: 0px;padding: 0px;background-color: inherit;line-height: 4;">
                                  <Icon type="md-git-network" size="20" />
                                </Button>
                                <div class="api" slot="content">
                                  <Input type="text" v-model="templateInfo.remark" placeholder="请输入备注" />
                                </div>
                              </Poptip>
                              </Col>
                                <Col span="4">
                                <FormItem style="margin: 10px 5px">
                                    <Button @click="removeInfoList(templat.infoList, idx)">删除</Button>
                                </FormItem>
                                </Col>
                            <!--</div>-->
                            <!--<Row>-->
                                <!--<FormItem style="margin: 10px 5px">-->
                                    <!--<Button type="dashed" long @click="addInfoList(row[week], templat, indes)" icon="md-add">添加新的食物</Button>-->
                                <!--</FormItem>-->
                            <!--</Row>-->
                        </Row>
                        <Row>
                            <FormItem style="margin: 10px 5px">
                                <Button type="dashed" long @click="addInfoList(row[week])" icon="md-add">添加新的食物</Button>
                            </FormItem>
                        </Row>
                    </Form>
                    <div v-else>
                        <Button type="primary" @click="editGetNutritions(updateInfoItem.infoList, row[week][0], 'basic')">基础物质</Button>
                        <Button type="primary" @click="editGetNutritions(updateInfoItem.infoList, row[week][0])" style="margin-left: 5px">其它物质</Button>
                    </div>
                </template>
            </Table>
            <div slot="footer">
                <Button type="primary" size="large" @click="updatePlan">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import Moment from 'moment'
    import PatientInfoModule from './patient-info-module-new.vue'
    import PatientDiagnose from './patient_diagnose_new.vue'
    import Viewer from 'viewerjs';
    export default {
        name: "diagnose-history-simple-table-expand",
        components: {
            PatientInfoModule,
            PatientDiagnose},
        comments: {
            PatientDiagnose,
            PatientInfoModule
        },
        props: {
            row: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                user: null,
                moment: Moment,
                dietPlanData: {
                    dietPlanTableColumns: [
                        {
                            title: '时间',
                            width: 60,
                            align: 'center',
                            ellipsis: true,
                            tooltip: true,
                            render: (h, params) => {
                                let week = ['早', '午', '晚', '加']
                                return h("span", week[params.index] + "餐")
                            }
                        },
                        {
                            title: '周天',
                            align: 'center',
                            render: (h, params) => {
                                let code = 6 + "" + (params.index + 1)
                                let hList = []
                                if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                    this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                        if (infoVO.type == code) {
                                            infoVO.infoList.forEach(function (info) {
                                                if (info.remark.length <= 0) {
                                                    hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                } else {
                                                    hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                }
                                            })
                                            return
                                        }
                                    })
                                }
                                return h("div", hList)
                            }
                        },
                        {
                            title: '周一',
                            align: 'center',
                            ellipsis: true,
                            tooltip: true,
                            render: (h, params) => {
                                let code = 0 + "" + (params.index + 1)
                                let hList = []
                                if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                    this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                        if (infoVO.type == code) {
                                            infoVO.infoList.forEach(function (info) {
                                                if (info.remark.length <= 0) {
                                                    hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                } else {
                                                    hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                }
                                            })
                                            return
                                        }
                                    })
                                }
                                return h("div", hList)
                            }
                        },
                        {
                            title: '周二',
                            align: 'center',
                            render: (h, params) => {
                                let code = 1 + "" + (params.index + 1)
                                let hList = []
                                if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                    this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                        if (infoVO.type == code) {
                                            infoVO.infoList.forEach(function (info) {
                                                if (info.remark.length <= 0) {
                                                    hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                } else {
                                                    hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                }
                                            })
                                            return
                                        }
                                    })
                                }
                                return h("div", hList)
                            }
                        },
                        {
                            title: '周三',
                            align: 'center',
                            render: (h, params) => {
                                let code = 2 + "" + (params.index + 1)
                                let hList = []
                                if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                    this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                        if (infoVO.type == code) {
                                            infoVO.infoList.forEach(function (info) {
                                                if (info.remark.length <= 0) {
                                                    hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                } else {
                                                    hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                }
                                            })
                                            return
                                        }
                                    })
                                }
                                return h("div", hList)
                            }
                        },
                        {
                            title: '周四',
                            align: 'center',
                            render: (h, params) => {
                                let code = 3 + "" + (params.index + 1)
                                let hList = []
                                if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                    this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                        if (infoVO.type == code) {
                                            infoVO.infoList.forEach(function (info) {
                                                if (info.remark.length <= 0) {
                                                    hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                } else {
                                                    hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                }
                                            })
                                            return
                                        }
                                    })
                                }
                                return h("div", hList)
                            }
                        },
                        {
                            title: '周五',
                            align: 'center',
                            render: (h, params) => {
                                let code = 4 + "" + (params.index + 1)
                                let hList = []
                                if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                    this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                        if (infoVO.type == code) {
                                            infoVO.infoList.forEach(function (info) {
                                                if (info.remark.length <= 0) {
                                                    hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                } else {
                                                    hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                }
                                            })
                                            return
                                        }
                                    })
                                }
                                return h("div", hList)
                            }
                        },
                        {
                            title: '周六',
                            key: 'age',
                            align: 'center',
                            render: (h, params) => {
                                let code = 5 + "" + (params.index + 1)
                                let hList = []
                                if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                    this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                        if (infoVO.type == code) {
                                            infoVO.infoList.forEach(function (info) {
                                                if (info.remark.length <= 0) {
                                                    hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                } else {
                                                    hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                }
                                            })
                                            return
                                        }
                                    })
                                }
                                return h("div", hList)
                            }
                        },
                    ],
                    itemSet: [{
                        dataTime: '早餐',
                        sev: '01',
                        one: '11',
                        tow: '21',
                        thr: '31',
                        fou: '41',
                        fiv: '51',
                        six: '61'
                    },
                        {
                            dataTime: '午餐',
                            sev: '02',
                            one: '12',
                            tow: '22',
                            thr: '32',
                            fou: '42',
                            fiv: '52',
                            six: '62'
                        },
                        {
                            dataTime: '晚餐',
                            sev: '03',
                            one: '13',
                            tow: '23',
                            thr: '33',
                            fou: '43',
                            fiv: '53',
                            six: '63'
                        },
                        {
                            dataTime: '加餐',
                            sev: '04',
                            one: '14',
                            tow: '24',
                            thr: '34',
                            fou: '44',
                            fiv: '54',
                            six: '64',
                        }],
                    dietPlanList: {
                        infoVOList: []
                    },
                }, // 饮食计划数据对象
                diagnosisModel: {
                    openDiagnosis: false,
                    diagnosisData: {
                        doctorAdviceId: '',
                        content: '',
                    }, // 处方数据对象
                    patientData: {}, // 患者数据对象
                    dietPlanData: {
                        dietPlanTableColumns: [
                            {
                                title: '时间',
                                width: 60,
                                align: 'center',
                                ellipsis: true,
                                tooltip: true,
                                render: (h, params) => {
                                    let week = ['早', '午', '晚', '加']
                                    return h("span", week[params.index] + "餐")
                                }
                            },
                            {
                                title: '周天',
                                align: 'center',
                                width: 130,
                                render: (h, params) => {
                                    let code = 6 + "" + (params.index + 1)
                                    let hList = []
                                    if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                        this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                            if (infoVO.type == code) {
                                                infoVO.infoList.forEach(function (info) {
                                                    if (info.remark.length <= 0) {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                    } else {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                    }
                                                })
                                                return
                                            }
                                        })
                                    }
                                    return h("div", hList)
                                }
                            },
                            {
                                title: '周一',
                                align: 'center',
                                width: 130,
                                ellipsis: true,
                                tooltip: true,
                                render: (h, params) => {
                                    let code = 0 + "" + (params.index + 1)
                                    let hList = []
                                    if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                        this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                            if (infoVO.type == code) {
                                                infoVO.infoList.forEach(function (info) {
                                                    if (info.remark.length <= 0) {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                    } else {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                    }
                                                })
                                                return
                                            }
                                        })
                                    }
                                    return h("div", hList)
                                }
                            },
                            {
                                title: '周二',
                                align: 'center',
                                width: 130,
                                render: (h, params) => {
                                    let code = 1 + "" + (params.index + 1)
                                    let hList = []
                                    if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                        this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                            if (infoVO.type == code) {
                                                infoVO.infoList.forEach(function (info) {
                                                    if (info.remark.length <= 0) {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                    } else {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                    }
                                                })
                                                return
                                            }
                                        })
                                    }
                                    return h("div", hList)
                                }
                            },
                            {
                                title: '周三',
                                align: 'center',
                                width: 130,
                                render: (h, params) => {
                                    let code = 2 + "" + (params.index + 1)
                                    let hList = []
                                    if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                        this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                            if (infoVO.type == code) {
                                                infoVO.infoList.forEach(function (info) {
                                                    if (info.remark.length <= 0) {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                    } else {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                    }
                                                })
                                                return
                                            }
                                        })
                                    }
                                    return h("div", hList)
                                }
                            },
                            {
                                title: '周四',
                                align: 'center',
                                width: 130,
                                render: (h, params) => {
                                    let code = 3 + "" + (params.index + 1)
                                    let hList = []
                                    if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                        this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                            if (infoVO.type == code) {
                                                infoVO.infoList.forEach(function (info) {
                                                    if (info.remark.length <= 0) {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                    } else {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                    }
                                                })
                                                return
                                            }
                                        })
                                    }
                                    return h("div", hList)
                                }
                            },
                            {
                                title: '周五',
                                align: 'center',
                                width: 130,
                                render: (h, params) => {
                                    let code = 4 + "" + (params.index + 1)
                                    let hList = []
                                    if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                        this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                            if (infoVO.type == code) {
                                                infoVO.infoList.forEach(function (info) {
                                                    if (info.remark.length <= 0) {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                    } else {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                    }
                                                })
                                                return
                                            }
                                        })
                                    }
                                    return h("div", hList)
                                }
                            },
                            {
                                title: '周六',
                                key: 'age',
                                width: 130,
                                align: 'center',
                                render: (h, params) => {
                                    let code = 5 + "" + (params.index + 1)
                                    let hList = []
                                    if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                        this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                            if (infoVO.type == code) {
                                                infoVO.infoList.forEach(function (info) {
                                                    if (info.remark.length <= 0) {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                    } else {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                    }
                                                })
                                                return
                                            }
                                        })
                                    }
                                    return h("div", hList)
                                }
                            },
                        ],
                        itemSet: [{
                            dataTime: '早餐',
                            sev: '01',
                            one: '11',
                            tow: '21',
                            thr: '31',
                            fou: '41',
                            fiv: '51',
                            six: '61'
                        },
                            {
                                dataTime: '午餐',
                                sev: '02',
                                one: '12',
                                tow: '22',
                                thr: '32',
                                fou: '42',
                                fiv: '52',
                                six: '62'
                            },
                            {
                                dataTime: '晚餐',
                                sev: '03',
                                one: '13',
                                tow: '23',
                                thr: '33',
                                fou: '43',
                                fiv: '53',
                                six: '63'
                            },
                            {
                                dataTime: '加餐',
                                sev: '04',
                                one: '14',
                                tow: '24',
                                thr: '34',
                                fou: '44',
                                fiv: '54',
                                six: '64',
                            }],
                        dietPlanList: {
                            infoVOList: []
                        },
                    }, // 饮食计划数据对象
                    nutritionalGoalData: {
                        nutritionalGoalTableColumns: [
                            {
                                type: 'index',
                                width: 80,
                                align: 'center',
                            },
                            {
                                title: '营养物质',
                                align: 'center',
                                minWidth: 150,
                                ellipsis: true,
                                tooltip: true,
                                render: (h, params) => {
                                    let item = params.row
                                    return h("span", item.nutritionType.name + '（' + item.nutritionType.forShort + '）- ' + item.nutritionType.englishName)
                                },
                            },
                            {
                                title: '含量',
                                align: 'center',
                                minWidth: 130,
                                ellipsis: true,
                                tooltip: true,
                                render: (h, params) => {
                                    let item = params.row
                                    return h("span", item.value + ' ' + item.nutritionType.unit)
                                },
                            },
                        ],//药物营养素表头
                        nutritionalGoalList: {
                            nutritionalGoalInfos: []
                        }
                    }, // 营养目标数据对象
                    dietGuidelinesData: {
                        dietGuidelineColumns: [
                            {
                                type: 'index',
                                width: 80,
                                align: 'center',
                            },
                            {
                                title: '原则名称',
                                key: 'name',
                                align: 'center',
                                ellipsis: true,
                                tooltip: true
                            },
                            {
                                title: '原则描述',
                                key: 'description',
                                align: 'center',
                                ellipsis: true,
                                tooltip: true
                            },
                            {
                                title: '禁食界限',
                                align: 'center',
                                ellipsis: true,
                                tooltip: true,
                                render: (h, params) => {
                                    if (params.row.detailList.length === 0) {
                                        return
                                    }
                                    return h("span", params.row.detailList[0].name)
                                }
                            }
                        ],
                        dataList: [
                            {
                                id: '',
                                name: '',
                                description: '',
                                detailList: [],
                            }
                        ]
                    }, // 饮食原则数据对象
                    doctorAdviceData: {}, // 医嘱数据对象
                    medicalRecordData: {}, // 病历数据对象
                }, // 处方模型
                medicalRecordData: {}, // 病历数据对象
                nutritionalGoalData: {
                    nutritionalGoalTableColumns: [
                        {
                            type: 'index',
                            width: 80,
                            align: 'center',
                        },
                        {
                            title: '营养物质',
                            align: 'center',
                            ellipsis: true,
                            tooltip: true,
                            render: (h, params) => {
                                let item = params.row
                                return h("span", item.nutritionType.name + '（' + item.nutritionType.forShort + '）- ' + item.nutritionType.englishName)
                            },
                        },
                        {
                            title: '含量',
                            align: 'center',
                            ellipsis: true,
                            tooltip: true,
                            render: (h, params) => {
                                let item = params.row
                                return h("span", item.value + ' ' + item.nutritionType.unit)
                            },
                        },
                    ],//药物营养素表头
                    nutritionalGoalList: {
                        nutritionalGoalInfos: []
                    }
                }, // 营养目标数据对象
                nutritionalGoalSearch: {},
                medicineUsage: [],
                updateModel: false, // 修改食谱
                tableLoading: false,
                columnsAdd:[
                    {
                        title: '时间',
                        width: 100,
                        key:'dataTime',
                        align: 'center',
                        fixed: 'left'
                    },
                    {
                        title: '周天',
                        key: 'age',
                        align: 'center',
                        slot:'sev',
                        width: 450,
                    },
                    {
                        title: '周一',
                        align: 'center',
                        slot:'one',
                        width: 450,
                    },
                    {
                        title: '周二',
                        align: 'center',
                        slot:'tow',
                        width: 450,
                    },
                    {
                        title: '周三',
                        key: 'age',
                        align: 'center',
                        slot:'thr',
                        width: 450,
                    },
                    {
                        title: '周四',
                        key: 'age',
                        align: 'center',
                        slot:'fou',
                        width: 450,
                    },
                    {
                        title: '周五',
                        key: 'age',
                        align: 'center',
                        slot:'fiv',
                        width: 450,
                    },
                    {
                        title: '周六',
                        key: 'age',
                        align: 'center',
                        slot:'six',
                        width: 450,
                    },
                ],
                itemAdd:[{dataTime:'早餐',one:'01',tow:'11',thr:'21',fou:'31',fiv:'41',six:'51',sev:'61'},
                    {dataTime:'午餐',one:'02',tow:'12',thr:'22',fou:'32',fiv:'42',six:'52',sev:'62'},
                    {dataTime:'晚餐',one:'03',tow:'13',thr:'23',fou:'33',fiv:'43',six:'53',sev:'63'},
                    {dataTime:'加餐',one:'04',tow:'14',thr:'24',fou:'34',fiv:'44',six:'54',sev:'64'},
                    {dataTime:'营养物质',one:'04',tow:'14',thr:'24',fou:'34',fiv:'44',six:'54',sev:'64'}],
                updateInfoItem: {},
                weekList:['sev','one','tow','thr','fou','fiv','six'],
                nutritionColumn:[
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '营养物质',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.foodNutritionId != null) {
                                return h('span',params.row.name+"("
                                    + params.row.forShort+")")
                            }
                        }
                    },
                    {
                        title: '含量',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.foodNutritionId != null) {
                                return h('span', params.row.value + " " + params.row.unit)
                            }
                        }
                    },
                ], // 营养物质列
                nutritionItems: [],
                foodMaterialAllList: [],
                itemIsFirst: true // 选中的历史是否是首诊
            }
        },
        methods: {
            findAllFoodMaterial(){
                this.$http.post('foodMaterial/list',{
                    isDeleted:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.foodMaterialAllList = []
                        for (let i in msg.data.list) {
                            if (msg.data.list[i].nutritionTypeList.length > 0) {
                                this.foodMaterialAllList.push(msg.data.list[i])
                            }
                        }
                    }else {
                        this.$Notice.error({title:'食材查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            // 修改或新增时显示当天的营养物质含量
            editGetNutritions (data, code, type) {
                this.tableLoading = false
                console.log('data', data)
                console.log('code', code)
                let foods= []
                let foodId = []
                for (let key of Object.keys(data)) {
                  if (key[0] == code) {
                    let info = data[key]
                    let temp = {
                      id: info.foodMaterialId,
                      quantity: info.value
                    }
                    let index = foodId.indexOf(info.foodMaterialId)
                    if (index > -1) {
                      foods[index].quantity = foods[index].quantity + info.value
                    } else if (info.foodMaterialId !== ''){
                      foods.push(temp)
                      foodId.push(info.foodMaterialId)
                    }
                  }
                }
                // data.forEach(function (info) {
                //     if (info.type[0] == code) {
                //         let temp = {
                //             id: info.foodMaterialId,
                //             quantity: info.value
                //         }
                //         let index = foodId.indexOf(info.foodMaterialId)
                //         if (index > -1) {
                //             foods[index].quantity = foods[index].quantity + info.value
                //         } else if (info.foodMaterialId !== ''){
                //             foods.push(temp)
                //             foodId.push(info.foodMaterialId)
                //         }
                //     }
                // })
                console.log(foods)
                // 调接口查询食材的营养物质含量，只/不显示热量/碳水化合物/蛋白质/脂肪
                this.basicNutritions (foods, type)
            },
            // 显示当天的基础营养物质含量
            basicNutritions (foods, type) {
                if (foods == null || foods.length <= 0) {
                    this.$Notice.error({title:'未选择食材，请先选择'});
                    return
                }
                let data = []
                this.$http.post('nutrition/calculate/nutrition',foods, {emulateJSON: false}).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        data = msg.data
                        console.log('data', data)
                        this.nutritionItems = []
                        data.forEach(item => {
                            if (type === 'basic') {
                                if (this.basicNutritionItems.indexOf(item.name) > -1) {
                                    this.nutritionItems.push(item)
                                }
                            } else {
                                if (this.basicNutritionItems.indexOf(item.name) < 0) {
                                    this.nutritionItems.push(item)
                                }
                            }

                        })
                        console.log('nutritionItems', this.nutritionItems)
                        this.nutritionModal = true
                    }else {
                        this.$Notice.error({title:'营养物质获取失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            editPlan (plan) {
              this.updateInfoItem.id = plan.id
              this.updateInfoItem.userId = plan.userId;
              let infoList = {}
              plan.infoVOList.forEach((i)=>{
                i.infoList.forEach((info)=> {
                    info['key'] = this.key++
                    info['unit'] = info.foodMaterial.unit
                    info['select'] = {edit: false, click: false}
                    if (!infoList[info.type])  infoList[info.type] = []
                    infoList[info.type].push(JSON.parse(JSON.stringify(info)))
                  })
                })
                this.$set(this.updateInfoItem, 'infoVOList', infoList)
                this.updateModel = true
            },
            changeSelect(value,templateInfo){
              if (templateInfo.foodMaterial != null && templateInfo.foodMaterial.name != null) {
                templateInfo.foodMaterial.name = value.label
              }
              templateInfo['foodMaterialName'] = value.label
              templateInfo.select.edit = templateInfo.select.click = false
            },
            addInfoList(week){
                if (!this.updateInfoItem.infoVOList[week]) {
                  this.$set(this.updateInfoItem.infoVOList, week,  [])
                }
                this.updateInfoItem.infoVOList[week].push({
                  foodMaterial: {},
                  foodMaterialId: '',
                  value: 0,
                  type: week,
                  remark:'',
                  select: {edit: true, click: true},
                  unit:''
                })
            },
            removeInfoList(list, index){
                list.splice(index, 1)
            },
            checkValue(value) {
                if (value === '' || value === null || value === undefined || value.length === 0) {
                    return true
                }
                return false
            }, // 空值判断
            updatePlan () {
                // let plan = []
                let flag = false
                let infoList = []
                for (let key of Object.keys(this.updateInfoItem.infoVOList)) {
                  infoList = infoList.concat(this.updateInfoItem.infoVOList[key])
                }
                infoList.forEach((TemplateInfo) => {
                  if (TemplateInfo.foodMaterialId.length <= 0 && TemplateInfo.value != null && TemplateInfo.value <= 0){
                    flag = true
                    return
                  }
                })
                // this.updateInfoItem.infoVOList.forEach(item => {
                //     for (let i = 0; i < item.infoList.length; i ++) {
                //         let food = item.infoList[i]
                //         if (food.foodMaterialId.length <= 0 && food.value != null && food.value <= 0) {
                //             flag = true
                //             return
                //         }
                //     }
//                    item.infoList.forEach(food => {
//                        if (food.foodMaterialId.length <= 0 && food.value != null && food.value <= 0) {
//                            flag = true
//                            return
//                        }
//                    })
//                     plan = plan.concat(item.infoList)
//                 })
                if (flag) {
                    return this.$Message.warning('食谱存在空行，请完善或删除');
                }
                this.$http.post('dietPlan/update',{
                    id:this.updateInfoItem.id,
                    userId:this.updateInfoItem.userId,
                    infoList:JSON.stringify(infoList)
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '食谱修改成功'});
                        this.updateModel = false
                        this.getDietPlanById(this.row.dietPlanId)
                    }else {
                        this.$Notice.error({title:'食谱修改失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            async getDoctorInfoByUserId(value) {
                if (this.checkValue(value)) {
                    return
                }
                this.$http.post('doctorAdvice/list', {
                    userId: value,
                    isDeleted: false,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.diagnosisModel.doctorAdviceData = msg.data.list[0]
                    } else {
                        this.$Notice.error({title: '医嘱查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            }, // 根据用户id获取医嘱
            async getDietPlanById(value) {
                this.dietPlanData.dietPlanList = null
                if (this.checkValue(value)) {
                    return
                }
                this.$http.post('dietPlan/list', {
                    id: value,
                    isDeleted: false,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.diagnosisModel.dietPlanData.dietPlanList = msg.data.list[0]
                    } else {
                        this.$Notice.error({title: '饮食计划查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            }, // 根据id获取饮食计划
            async getNutritionalGoalById(value) {
                this.diagnosisModel.nutritionalGoalData.nutritionalGoalList = null
                this.$http.post('nutritionalGoal/list', {
                    id: value,
                    isDeleted: false,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.diagnosisModel.nutritionalGoalData.nutritionalGoalList = msg.data.list[0]
                    } else {
                        this.$Notice.error({title: '营养目标列表查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            }, // 根据id获取营养目标

            async getDietGuidelinesByUserId(value) {
                this.$http.post('dietGuidelines/listUser', {
                    userId: value,
                    isDeleted: false,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        console.log(msg)
                        this.diagnosisModel.dietGuidelinesData.dataList = msg.data
                    } else {
                        this.$Notice.error({title: '营养原则查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            }, // 根据用户id获取饮食原则
            async getMedicineUsageByMedicalRecord(value) {
                this.$http.post('medicalRecord/getMedicineUsage', {
                    medicalRecordId: value
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.medicineUsage = msg.data
                        console.log('medicineUsage', this.medicineUsage)
                    } else {
                        this.$Notice.error({title: '病历列表查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            },// 根据病历id获取药品用法
            initImageTools() {
                //初始化 viewerjs
                setTimeout(()=>{
                    this.ViewerDom = document.getElementById('imgToolsExpand');
                    const viewer = new Viewer(this.ViewerDom, {
                        url: "data-original",
                        show: function () {
                            viewer.update()
                        }
                    });
                }, 300)
            },
            async getMedicalRecordById(value) {
                this.$http.post('medicalRecord/getOrder', {
                    medicalRecordId: value,
                    isDeleted: false,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.diagnosisModel.medicalRecordData = msg.data
                        setTimeout(() => {
                            this.initImageTools()
                        }, 200)
                    } else {
                        this.$Notice.error({title: '病历列表查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            }, // 根据病历id获取病历信息
            // 根据生日获取年龄
            getAgeByBirthday(birthday) {
                if (!birthday) {
                    return
                }
                let returnAge;
                let strBirthdayArr = birthday.split("-");
                let birthYear = strBirthdayArr[0];
                let birthMonth = strBirthdayArr[1];
                let birthDay = strBirthdayArr[2];

                let d = new Date();
                let nowYear = d.getFullYear();
                let nowMonth = d.getMonth() + 1;
                let nowDay = d.getDate();

                if (nowYear == birthYear) {
                    returnAge = 0;//同年 则为0岁
                } else {
                    let ageDiff = nowYear - birthYear; //年之差
                    if (ageDiff > 0) {
                        if (nowMonth == birthMonth) {
                            let dayDiff = nowDay - birthDay;//日之差
                            if (dayDiff < 0) {
                                returnAge = ageDiff - 1;
                            } else {
                                returnAge = ageDiff;
                            }
                        } else {
                            let monthDiff = nowMonth - birthMonth;//月之差
                            if (monthDiff < 0) {
                                returnAge = ageDiff - 1;
                            } else {
                                returnAge = ageDiff;
                            }
                        }
                    } else {
                        returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天
                    }
                }

                return returnAge;//返回周岁年龄
            }
        },
        created() {
            this.$store.commit('setCurrentPatient', JSON.parse(sessionStorage.getItem('currentPatient')))
            this.user = this.$store.state.currentPatient
            if (this.user == null) {
                this.$Notice.error({title: '数据异常，请重新登录'})
                return
            }
            this.user['age'] = this.getAgeByBirthday(this.user.birthday)
             this.itemIsFirst = this.row.medicalRecordVO.isFirst
            this.diagnosisModel.openDiagnosis = true
             this.diagnosisModel.diagnosisData = this.row //处方对象数据
            this.diagnosisModel.patientData = this.user // 患者对象数据

             console.log('this.row', this.diagnosisModel.patientData)
            this.getDoctorInfoByUserId(this.row.userId) // 调用医嘱接口
            this.getDietPlanById(this.row.dietPlanId) // 调用饮食计划接口
            this.getNutritionalGoalById(this.row.nutritionalGoalId) // 调用营养目标接口
            this.getMedicalRecordById(this.row.medicalRecordId) // 调用病历查询接口
            this.getMedicineUsageByMedicalRecord(this.row.medicalRecordId) // 调用药品/营养素用法查询
            this.findAllFoodMaterial()
            // this.getDietGuidelinesByUserId(this.user.id) // 调用饮食原则接口
        }
    }
</script>

<style scoped>
    .bold-label{
        font-size: 14px;
        font-weight: bold;
    }
    .expand-row{
        margin-bottom: 16px;
    }
    .card-title{
        height: 20px !important;
    }
    .card-box{
        margin-bottom: 10px;
    }
</style>
